import { useEffect, useState } from "react";
import { Snackbar } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import { Link, useNavigate } from "react-router-dom";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   PointElement,
//   LineElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";
import { Line } from "react-chartjs-2";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import CurrencyInput from "react-currency-input";
import SellingService from "../../services/SellingService";
import CurrencyService from "../../services/CurrencyService";
import UtilsFormuleSell from "../../utils/UtilsFormuleSell";
import withLoader from "../../components/layouts/WithLoader";
const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddProductStockToSell = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const [unitPrice, setUnitPrice] = useState(0);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState();
  const [warehousesSource, setWarehousesSource] = useState(null);
  const [warehousesSourceAll, setWarehousesSourceAll] = useState(null);

  const [productStock, setProductStock] = useState(null);
  const [formValid, setFormValid] = useState(false);
  const [name, setName] = useState(null);

  const [value, setValue] = useState(0);
  const [valueGain, setValueGain] = useState(0);

  const [selectedOption, setSelectedOption] = useState(null);
  const [allWarehouseSource, setAllWarehouseSource] = useState([{}]);
  const [warehouseSourceId, setWarehouseSourceId] = useState(0);
  const [warehouseSelectPlaceHolder, setWarehouseSelectPlaceHolder] =
    useState("Choisir...");
  const [devise, setDevise] = useState("");
  const [nameProduct, setNameProduct] = useState("");

  const [extrats, setExtrats] = useState([]);
  const [labels, setLabels] = useState([]);
  const [labelsSale, setLabelsSale] = useState([]);

  const [dataCharts, setDataCharts] = useState([]);

  const [dataChartsSale, setDataChartsSale] = useState([]);
  const [product, setProduct] = useState();

  const [average, setAverage] = useState(0);
  const [lastPrice, setLastPrice] = useState(0);
  const [averageSale, setAverageSale] = useState(0);
  const [lastPriceSale, setLastPriceSale] = useState(0);
  const [estimationPrice, setEstimationPrice] = useState(0);
  const [tauxChange, setTauxChange] = useState(0);
  const [labelDevise, setLabelDevise] = useState("Prix de vente unitaire");
  const [showFinalPrice, setShowFinalPrice] = useState(false);
  const [finalPrix, setFinalPrix] = useState(0);

  useEffect(() => {
    WarehouseService.getAllWarehouseById(
      getCurrentUserId(),
      sessionStorage.getItem("idWarehouseSell")
    )
      .then((response) => {
        if (response.data.success) {
          // console.log("setWarehousesSource", response.data.success);
          setWarehousesSource(response.data.success);
          setProductStock(response.data.success.productStocks[0]);
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
    WarehouseService.getAllRealWarehouse(getCurrentUserId(), 0)
      .then((response) => {
        if (response.data.success) {
          response.data.success.map((element) => {
            let exist = false;
            if (allWarehouseSource.length !== 0) {
              for (let index = 0; index < allWarehouseSource.length; index++) {
                if (allWarehouseSource[index].value === element?.id) {
                  exist = true;
                  break;
                }
              }
            }
            if (element?.id !== undefined && exist === false) {
              setAllWarehouseSource((oldArray) => [
                ...oldArray,
                {
                  value: element.id,
                  label: element.name,
                  customElements: {
                    devise: element.devise,
                  },
                },
              ]);
            }
          });
        } else {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : pas de dépôt");
        }
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      });
    startLoading();
    setDataChartsSale([]);
    getListLabelsSale([]);
    WarehouseService.dataForFixedSellingPrice(
      getCurrentUserId(),
      sessionStorage.getItem("idWarehouseSell"),
      sessionStorage.getItem("idProductStock")
    )
      .then((response) => {
        setDataChartsSale(response.data.dataChartsSale);
        getListLabelsSale(response.data.dataChartsSale);
        setProduct(response.data.product);
        setDataCharts(response.data.dataCharts);
        getListLabels(response.data.dataCharts);
        setAverage(response.data.average);
        setLastPrice(response.data.lastPrice);
        setEstimationPrice(estimatePrice(response.data.average));
        setLastPriceSale(response.data.lastPriceSale)
        setAverageSale(response.data.averageSale)
      })
      .catch((e) => {
        console.log("error in getAllRealWarehouse", e);
      })
      .finally(() => {
        stopLoading();
      });
  }, []);
  useEffect(() => {
    warehousesSourceAll &&
      warehousesSourceAll.map((element) => {
        let exist = false;
        if (allWarehouseSource.length !== 0) {
          for (let index = 0; index < allWarehouseSource.length; index++) {
            if (allWarehouseSource[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }
        if (element?.id !== undefined && exist === false) {
          setAllWarehouseSource((oldArray) => [
            ...oldArray,
            {
              value: element.id,
              label: element.name,
              customElements: {
                devise: element.devise,
              },
            },
          ]);
        }
        //here
      });
  }, [warehousesSource]);

  function estimatePrice(price) {
    return (price * 1.2).toLocaleString(undefined, {
      maximumFractionDigits: 3,
    });
  }
  function getListLabels(dataCharts) {
    dataCharts &&
      dataCharts.map((element) => {
        setLabels((oldArray) => [...oldArray, element.label]);
      });
  }

  function getListLabelsSale(chart) {
    chart &&
      chart.map((element) => {
        setLabelsSale((oldArray) => [...oldArray, element.label]);
      });
  }



  const addProductSell = () => {
    console.log("unitPrice", unitPrice);
    console.log("extrats", extrats);

    let model = {
      idProduct: sessionStorage.getItem("idProductStock"),
      idUser: getCurrentUserId(),
      productWarehousePrices: extrats,
    };
    console.log("model", JSON.stringify(model));
    SellingService.setSellingPrice(model)
      .then((result) => {
        console.log("response", result);
        setOpenSuccessAlert(true);
        setSuccessAlertText("Enregistrement avec succées");
        setTimeout(() => {
          navigate(`/productSell`);
        }, 2000);
      })
      .catch((e) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur :erreur serveur ");
      });
  };
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };

  const data = {
    labels:labels,
    datasets: [
      {
        label: "Prix d'achat",
        borderWidth: 2,
        lineTension: 0.5,
        fill: false,
        data: dataCharts.map((element) => element.data),
        borderColor: "black",
        backgroundColor: "black",
      },
    ],
  };

  const dataSale = {
    labels:labelsSale,
    datasets: [
      {
        label: "Prix de vente",
        borderWidth: 2,
        lineTension: 0.5,
        fill: false,
        data: dataChartsSale.map((element) => element.data),
        borderColor: "black",
        backgroundColor: "black",
      },
    ],
  };
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Les Prix du produit",
      },
    },
  };

  const optionsSale = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      title: {
        display: true,
        text: "Les Prix du produit",
      },
    },
  };

  // const optionsSale = {
  //   responsive: true,
  //   plugins: {
  //     legend: {
  //       position: "top",
  //     },
  //     title: {
  //       display: true,
  //       text: "Sales Data Over Time",
  //     },
  //   },
  //   scales: {
  //     x: {
  //       title: {
  //         display: true,
  //         text: "Date",
  //       },
  //     },
  //     y: {
  //       title: {
  //         display: true,
  //         text: "Sales Amount",
  //       },
  //     },
  //   },
  // };

  const onChangeSelectedWarehouseSource = (selectedOptionn) => {
    setSelectedOption();
    setWarehouseSourceId(selectedOptionn.value);
    setWarehouseSelectPlaceHolder(selectedOptionn.label);
    // console.log("devise warehouse", selectedOptionn.customElements.devise);
    setDevise(selectedOptionn.customElements.devise);
  };

  const changeValeur = (event) => {
    setValue(event.target.value.replace(",", ""));
  };
  // const changeValueGain = (event) => {
  //   setValueGain(event.target.value);
  // };
  const onHandleClickTauxChange = () => {
    if (devise) {
      getCurrencyRate(devise);
    }
  };
  // const onHandleClickTauxGain = () => {
  //   if (warehouseSourceId && valueGain !== 0) {
  //     getFinalPrice(valueGain);
  //   }
  // };
  const labelDeviseTest = () => {
    return labelDevise;
  };
  const getCurrencyRate = (deviseChoosen) => {
    try {
      CurrencyService.getTauxChage(deviseChoosen).then((response) => {
        setTauxChange(response.data);
        setLabelDevise(
          "TAUX D'ECH (" +
          response.data.toLocaleString(undefined, {
            maximumFractionDigits: 3,
          }) +
          ") ESTI " +
          deviseChoosen +
          "(" +
          (parseFloat(estimationPrice) / response.data).toPrecision(3) +
          ")"
        );
      });
    } catch (error) {
      console.log("error currency", error);
    }
  };


  function createUI() {
    const animatedComponents = makeAnimated();

    return (
      <div class="row">
        <div class="col-md-4">
          <label>Dépôt </label>
          <Select
            styles={styles}
            closeMenuOnSelect={true}
            components={animatedComponents}
            defaultValue={selectedOption}
            onChange={onChangeSelectedWarehouseSource}
            options={allWarehouseSource}
            placeholder={warehouseSelectPlaceHolder}
          />
        </div>
        <div class="col-md-4">
          <div className="input-group">
            <label>{labelDeviseTest()} </label>

            <div className="input-group-prepend" style={{ width: "85%" }}>
              <CurrencyInput
                id="montantDevise"
                className="form-control"
                precision="3"
                value={value}
                onChangeEvent={changeValeur}
              />
            </div>
            <div className=" input-group-append">
              <button
                onClick={onHandleClickTauxChange}
                type="button"
                class="btn btn-dark"
              >
                {" "}
                <i class="fas fa-solid fa-dollar-sign"></i>{" "}
              </button>
            </div>
          </div>
        </div>
        {/* <div class="col-md-4">
          <div className="input-group">
            <label>Marge de gain: </label>

            <div className="input-group-prepend" style={{ width: "85%" }}>
              <CurrencyInput
                id="montantDevise"
                className="form-control"
                precision="3"
                value={valueGain}
                onChangeEvent={changeValueGain}
              />
            </div>
            <div className=" input-group-append">
              <button
                onClick={onHandleClickTauxGain}
                type="button"
                class="btn btn-dark"
              >
                {" "}
                <i class="fas fa-solid fa-percent"></i>{" "}
              </button>
            </div>
          </div>
        </div> */}
        <div class="col-md-4">
          {/* <div className="input-group"> */}
          <br />
          <br />
          <label> {devise}</label>
          {/* </div> */}
        </div>
      </div>
    );
  }
  function addClick() {
    setExtrats((oldArray) => [
      ...oldArray,
      {
        warehouseId: warehouseSourceId,
        warehouseName: warehouseSelectPlaceHolder,
        value: value,
        // valueGain: valueGain,
        devise: devise,
      },
    ]);

    setWarehouseSourceId(0);
    setWarehouseSelectPlaceHolder("");
    setDevise("");
    setSelectedOption(null);
  }
  const removeExtrat = (index) => {
    var array = [...extrats];

    if (index !== -1) {
      array.splice(index, 1);
      setExtrats(array);
    }
  };
  function addExtratToView() {
    if (extrats.length === 0) {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else if (
      extrats.length === 1 &&
      extrats[0]["warehouseId"] === "" &&
      extrats[0]["warehouseName"] === "" &&
      extrats[0]["value"] === ""
    ) {
      return (
        <div class="row">
          <div class="col-xs-12 table-responsive">
            <h1></h1>
          </div>
        </div>
      );
    } else {
      return (
        <div className="table-responsive">
          <table className="table table-striped">
            <tbody>
              {extrats.map((extrat, i) => (
                <tr className="text-center">
                  <td>{extrat.warehouseId}</td>
                  <td>{extrat.warehouseName}</td>
                  <td>{extrat.value}</td>
                  {/* <td>{extrat.valueGain}</td> */}
                  <td>{extrat.devise}</td>

                  <td>
                    <button
                      type="button"
                      class="btn btn-danger float-right"
                      onClick={() => removeExtrat(i)}
                    >
                      <i class="fa fa-minus"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      );
    }
  }

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      {/* <br /> */}
      <section className="content-header">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-6"></div>
            <div className="col-md-6">
              <ol class="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <Link to="/" style={{ color: "black" }}>
                    Home
                  </Link>
                </li>

                <li className="breadcrumb-item">
                  <Link to="/productSell" style={{ color: "black" }}>
                    Prix de vente
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "black" }}
                >
                  Ajouter
                </li>
              </ol>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
        {warehousesSource &&
          <div className="callout callout-info">
            <h5> Produit de vente : {product}</h5>

            <p className="float-right">{warehousesSource.name}</p>
<br/>
          </div>}

          <div className="callout callout-info">
            <h5>Info</h5>
            <p>
              Remarque : Pour avoir une estimation correcte merci de vérifier
              que le dépôt est le dépôt central
            </p>
          </div>
          <>
            <div className="row">
              <div className="col-md-12">
                {warehousesSource && productStock && (
                  <div className="row">
                    <div className="col-sm-6">
                      <div className="card card-dark">
                        <div className="card-header">
                          <h5 className="card-title">
                           ACHAT
                          </h5>
                        </div>
                        <div class="card-body">
                       
                          <div className="row">
                            <div className="col-sm-12">
                              <Line
                                // height={"50%"}
                                options={options}
                                data={data}
                              />
                            </div>
                          </div>
                         

                          <br />
                          <div className="row">

                            <div className="col-sm-6">
                              <div class="info-box">
                                <span class="info-box-icon  bg-dark">
                                  <i class="fas fa-chart-line"></i>
                                </span>
                                <div class="info-box-content">
                                  <span class="info-box-text">
                                    Prix d'achat Moyen
                                  </span>
                                  <span class="info-box-number">{average}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div class="info-box">
                                <span class="info-box-icon bg-dark">
                                  <i class="fas fa-shopping-cart"></i>
                                </span>
                                <div class="info-box-content">
                                  <span class="info-box-text">
                                    Dérnier prix d'achat
                                  </span>
                                  <span class="info-box-number">
                                    {lastPrice}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="card card-dark">
                        <div className="card-header">
                          <h5 className="card-title">
                            VENTE
                          </h5>
                        </div>
                        <div class="card-body">
                          <div className="row">
                            <div className="col-sm-12">
                              <Line
                                // height={"50%"}
                                options={optionsSale}
                                data={dataSale}
                              />
                            </div>
                          </div>{" "}
                          <br />
                          <div className="row">
                           
                            <div className="col-sm-6">
                              <div class="info-box">
                                <span class="info-box-icon  bg-dark">
                                  <i class="fas fa-chart-line"></i>
                                </span>
                                <div class="info-box-content">
                                  <span class="info-box-text">
                                    Prix de vente Moyen
                                  </span>
                                  <span class="info-box-number">{averageSale}</span>
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-6">
                              <div class="info-box">
                                <span class="info-box-icon bg-dark">
                                  <i class="fas fa-shopping-cart"></i>
                                </span>
                                <div class="info-box-content">
                                  <span class="info-box-text">
                                    Dérnier prix d'e vente
                                  </span>
                                  <span class="info-box-number">
                                    {lastPriceSale}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>{" "}
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div className="card card-dark">
                  <div className="card-header with-border">
                    <h3 className="card-title">Ajouter le prix de vente: </h3>
                  </div>
                  <div className="card-body">
                    {createUI()}
                    <button
                      type="button"
                      class="btn btn-dark float-right"
                      onClick={addClick}
                    >
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  {addExtratToView()}
                </div>
              </div>
            </div>
            <div class="row">
              <div className="col-sm-7"></div>
              <div className="col-sm-5">
                <button
                  style={{ marginBottom: "5%" }}
                  className="btn btn-dark float-right"
                  onClick={addProductSell}
                >
                  Confirmer
                </button>
              </div>
            </div>
          </>
        </div>
      </section>
      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </div>
  );
};
export default withLoader(AddProductStockToSell);
